import useSWR from 'swr';
import packageJson from '../../../package.json';
import environments from '../../environments.json';
const env = import.meta.env.VITE_ENV || 'staging';

const unauthenticatedFetcher = async (path: string) => {
  const basePath = environments[env].apiUrl;
  const url = `${basePath}${path}`;
  const res = await fetch(url);

  if (res.status === 404) {
    return undefined;
  }

  if (!res.ok) {
    throw new Error();
  }

  return res.json();
};

export default function useBmsVersion() {
  return useSWR<BMSLabellingInfo>(`/bms/version/partner_portal/${packageJson.version}`, unauthenticatedFetcher);
}
